import React from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Paper,
  Button,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  selectFormControl: {
    width: "125px"
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
  dangerButton: {
    marginLeft: "10px",
    color: "#fff",
    backgroundColor: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgb(154, 0, 54)",
    },
  },
}));

export default function Form({ plan, submit, deleteReserve, isEdit }) {
  const classes = useStyles();
  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [isShowModal, setIsShowModal] = React.useState(false);
  const minDate = dayjs().add(1, "day");

  const [initTypes, setInitTypes] = React.useState([]);
  const [initMaxWords, setInitMaxWords] = React.useState({});
  const [initMaxTweets, setInitMaxTweets] = React.useState({});

  // ADD 2023.09.30 SLCプラン
  const [initFilterhose, setInitFilterhose] = React.useState([]);

  const [contractType, setContractType] = React.useState("");
  const [fhUser, setFhUser] = React.useState("");
  const [fhPassword, setFhPassword] = React.useState("");
  const [maxWords, setMaxWords] = React.useState("");
  const [minWords, setMinWords] = React.useState("");
  const [maxTweets, setMaxTweets] = React.useState("");
  const [maxCurrent, setMaxCurrent] = React.useState("");
  const [validFrom, setValidFrom] = React.useState(null);

  React.useEffect(() => {
    stateError.initialize();
  }, []);

  React.useEffect(() => {
    if (!plan) return;
    setContractType(plan.contractType);
    setFhUser(plan.fhUser);
    setFhPassword(plan.fhPassword);
    setMaxWords(plan.maxWords);
    setMinWords(1);
    setMaxTweets(plan.maxTweets);
    setMaxCurrent(plan.maxCurrent);
    setValidFrom(plan.validFrom);
  }, [plan]);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchContracts();
  }, [auth.state.token]);

  React.useEffect(() => {
    if (contractType === "slc") {
      setMinWords(20);
    } else {
      setMinWords(1);
    }
    // ADD 2023.09.30 SLCプラン（統一する）
    if (!initFilterhose[contractType]) {
      setFhUser("");
      setFhPassword("");
    }
    // 追加したSLCプランはFHキーワード数の最低値が100
    if (!initFilterhose[contractType] && contractType !== "slc" && contractType !== "ruby") {
      setMinWords(100);
    }
    if (contractType === "ruby") {
      setMaxWords(5);
      setMinWords(1);
    }
  }, [contractType]);

  const openDialog = () => {
    setIsShowModal(true);
  };

  const onClickDelete = () => {
    deleteReserve();
    setIsShowModal(false);
  };


  const fetchContracts = () => {
    request({
      method: "GET",
      url: `admin/contracts`,
    })
      .then((result) => {
        setInitTypes(result.data.data.types);
        setInitMaxWords(result.data.data.max_words);
        setInitMaxTweets(result.data.data.max_tweets);
        setMaxCurrent(result.data.data.max_tweets);

        // ADD 2023.09.30 SLCプラン
        setInitFilterhose(result.data.data.filterhose);
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  // 契約タイプ変更に伴う値変更
  const changeType = (event) => {
    setContractType(event.target.value);
    setMaxWords(initMaxWords[event.target.value]);
    setMaxTweets(initMaxTweets[event.target.value]);
  }

  // FHユーザ名/パスワードの条件付き必須チェック
  ValidatorForm.addValidationRule('checkFhUserPassword', (value) => {
    // 契約タイプが「slc」であれば必須チェック不要
    // ADD 2023.09.30 SLCプラン
    // if (contractType != "slc") {
    if (initFilterhose[contractType]) {
      if (value) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  });

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <>
      <Grid>
        <ValidatorForm
          onSubmit={(e) => {
            e.preventDefault();
            submit(
              { 
                contractType,
                fhUser,
                fhPassword,
                maxWords,
                maxTweets,
                maxCurrent,
                validFrom,
              }
            );
          }}
          onError={onError}
        >
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" color="primary">
              {isEdit ? "プラン変更予約更新" : "プラン変更予約登録"}
            </Typography>
            <Grid container>
              <Grid item xs={12} className={classes.wrapper}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    label="プラン変更適用日"
                    format="yyyy-MM-dd"
                    value={validFrom}
                    minDate={minDate}
                    minDateMessage={
                      (messages.validation.minDate).replace(
                        "$1", 
                        minDate.format("YYYY-MM-DD")
                      )
                    }
                    onChange={(date) => setValidFrom(dayjs(date).format("YYYY-MM-DD 00:00:00"))}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} className={classes.wrapper}>
                <FormControl className={classes.selectFormControl}>
                  <InputLabel>契約タイプ</InputLabel>
                  <Select
                    value={contractType}
                    onChange={changeType}
                  >
                    {initTypes.map((row, index) => 
                      <MenuItem key={index} value={row}>{row}</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} className={classes.wrapper}>
                <TextValidator
                  label="FHユーザ名"
                  fullWidth
                  value={fhUser}
                  onChange={(event) => {
                    setFhUser(event.target.value);
                  }}
                  type="text"
                  // UPDATE 2023.09.30 SLCプラン
                  //disabled={contractType === "slc"}
                  disabled={!initFilterhose[contractType]}
                  validators={['checkFhUserPassword']}
                  errorMessages={[
                    messages.validation.required, 
                  ]}
                />
              </Grid>
              <Grid item xs={12} className={classes.wrapper}>
                <TextValidator
                  label="FHパスワード"
                  autoComplete="new-password"
                  fullWidth
                  value={fhPassword}
                  onChange={(event) => {
                    setFhPassword(event.target.value);
                  }}
                  type={"text"}
                  // UPDATE 2023.09.30 SLCプラン
                  //disabled={contractType === "slc"}
                  disabled={!initFilterhose[contractType]}
                  validators={['checkFhUserPassword']}
                  errorMessages={[
                    messages.validation.required, 
                  ]}
                />
              </Grid>
              <Grid item xs={12} className={classes.wrapper}>
                <TextValidator
                  label="FHキーワード数"
                  fullWidth
                  value={maxWords}
                  onChange={(event) => {
                    setMaxWords(event.target.value);
                  }}
                  type="number"
                  InputProps={{ inputProps: { min: minWords, step: 10} }}
                  validators={['required', 'minNumber:' + minWords]}
                    errorMessages={[
                    messages.validation.required, 
                    ((messages.validation.minNumber).replace("$1", "FHキーワード数")).replace("$2", minWords)
                  ]}
                  // UPDATE 2023.09.30 SLCプラン
                  //disabled={contractType != "slc"}
                  disabled={initFilterhose[contractType] ||  contractType === "ruby"}

                />
              </Grid>
              <Grid item xs={12} className={classes.wrapper}>
                <TextValidator
                  label="FH取得上限値"
                  fullWidth
                  value={maxTweets}
                  type="text"
                  disabled
                />
              </Grid>
            </Grid>
          </Paper>

          {stateError.state.isError && (
            <div className={classes.messsageWrapper}>
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="error"
                className={classes.toast}
              >
                {stateError.state.errorMsg}
              </MuiAlert>
            </div>
          )}
          <Grid container justifyContent="center" className={classes.wrapper}>
            <Button type="submit" variant="contained" color="primary">
              {isEdit ? "更新" : "登録"}
            </Button>
            {isEdit && (
              <Button 
                type="button" 
                variant="contained" 
                className={classes.dangerButton}
                onClick={() => openDialog()}
              >
                削除
              </Button>
            )}
          </Grid>
        </ValidatorForm>
      </Grid>
      <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
        <DialogContent>
          <DialogContentText>
            { "本当に削除してよろしいですか？" }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => onClickDelete() }>
            はい
          </Button>
          <Button color="primary" onClick={() => setIsShowModal(false)}>
            いいえ
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
